
      import CloseCircleFilled from './close-circle-filled.vue'
      import type { App, Plugin } from 'vue'

      export const CloseCircleFilledPlugin: Plugin = {
        install(app: App) {
          app.component('CloseCircleFilled', CloseCircleFilled)
        },
      }
      export { CloseCircleFilled }
      